/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Manual_ProvinceInputs */

const vi_carrier_manual_province = /** @type {(inputs: Carrier_Manual_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã tỉnh (hãng)`)
};

/**

* @param {Carrier_Manual_ProvinceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_manual_province = /** @type {((inputs?: Carrier_Manual_ProvinceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Manual_ProvinceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_manual_province(inputs)
});